import { MapPin, Phone, Clock, Star } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export default function RestaurantHeader({ restaurant }) {
  const priceSymbols = '$'.repeat(restaurant.price_range || 2);
  
  return (
    <div className="bg-white border-b sticky top-0 z-40">
      {/* Cover Image */}
      {restaurant.cover_image_url && (
        <div className="h-32 md:h-48 w-full overflow-hidden">
          <img 
            src={restaurant.cover_image_url} 
            alt={restaurant.name}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      
      {/* Restaurant Info */}
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex items-start gap-4">
          {/* Logo */}
          {restaurant.image_url && (
            <div className="h-16 w-16 md:h-20 md:w-20 rounded-lg overflow-hidden flex-shrink-0 border-2 border-white shadow-md -mt-8 bg-white">
              <img 
                src={restaurant.image_url} 
                alt={restaurant.name}
                className="h-full w-full object-cover"
              />
            </div>
          )}
          
          {/* Info */}
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 truncate">
                  {restaurant.name}
                </h1>
                <p className="text-sm text-gray-600 mt-1">
                  {restaurant.cuisine_type} • {priceSymbols}
                </p>
              </div>
              
              {/* Status Badge */}
              <Badge 
                variant={restaurant.is_open ? "success" : "secondary"}
                className={restaurant.is_open ? "bg-green-500 hover:bg-green-600" : ""}
              >
                {restaurant.is_open ? "Open" : "Closed"}
              </Badge>
            </div>
            
            {/* Rating & Details */}
            <div className="flex items-center gap-4 mt-3 flex-wrap text-sm text-gray-600">
              {restaurant.rating > 0 && (
                <div className="flex items-center gap-1">
                  <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                  <span className="font-medium">{restaurant.rating.toFixed(1)}</span>
                </div>
              )}
              
              {restaurant.address && (
                <div className="flex items-center gap-1">
                  <MapPin className="h-4 w-4" />
                  <span className="truncate max-w-xs">{restaurant.address}</span>
                </div>
              )}
              
              {restaurant.phone && (
                <div className="flex items-center gap-1">
                  <Phone className="h-4 w-4" />
                  <span>{restaurant.phone}</span>
                </div>
              )}
            </div>
            
            {restaurant.description && (
              <p className="text-sm text-gray-600 mt-2 line-clamp-2">
                {restaurant.description}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
